import { render, staticRenderFns } from "./customSetting.vue?vue&type=template&id=4f3a64a0&scoped=true"
import script from "./customSetting.vue?vue&type=script&lang=js"
export * from "./customSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3a64a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f3a64a0')) {
      api.createRecord('4f3a64a0', component.options)
    } else {
      api.reload('4f3a64a0', component.options)
    }
    module.hot.accept("./customSetting.vue?vue&type=template&id=4f3a64a0&scoped=true", function () {
      api.rerender('4f3a64a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userSystem/setting/components/customSetting.vue"
export default component.exports